import { createGlobalStyle } from 'styled-components';

import SourceSansProBlack from '@/assets/fonts/source-sans-pro-black.woff';

const VariationStyles = createGlobalStyle`
  @font-face {
    font-family: 'SourceSansProBlack';
    src: url(${SourceSansProBlack});
    font-weight: 900;
    font-style: normal;
  }

  .generated-images-holder-var10 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }
  .image-holder-var10 {
    width: 100%;
    position: relative;
    height: 1350px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #efeeed;
    padding: 64px 0 52px;
  }
 
  .bottom-text-var10 {
    font-size: 55px;
    line-height: 1.2;
    color: #242424;
    font-family: SourceSansProBlack;
    z-index: 1;
    display: flex;
    gap: 40px;
    width: 942px;
    align-items: center;
    height: 338px;
    span {
      width: 12px;
      background-color: #cf4912;
      height: 100%;
      margin-left: 6px;
      flex-shrink: 0;
    }
    .bottom-watermark-var10 {
      font-size: 40px;
      color: #c0c0c0;
      letter-spacing: 1.4px;
      margin-top: 2px;
    }
    p {
      display: inline-block;
      margin: 0;
      padding: 0;
      text-transform: uppercase;
      letter-spacing: 2.1px;
    }
  }
  .image-wrap-var10 {
    position: relative;
    display: flex;
  }

  .full-image-var10 {
    width: 954px;
    height: 848px;
    border: solid 12px #fff;
    border-radius: 20px;
    object-fit: cover;
    position: relative;
  }

  .circle-image-var10 {
    object-fit: cover;
    border-radius: 50%;
    border: solid 12px white;
    width: 434px;
    height: 434px;
    position: absolute;
    top: 548px;
    right: 21px;
  }
  .actual-photo-var10 {
    position: absolute;
    left: 12px;
    bottom: 12px;
    height: 72px;
  }
  .actual-photo-var10--top {
    top: 12px;
    bottom: auto;
  }
`;

export default VariationStyles;
